import Vue from "vue";
import { mapState } from "vuex";

import comboComponent from "@/components/child/form/combo.vue";
import dateTimePickerComponent from "@/components/child/form/datetimepicker.vue";
import fieldsetComponent from "@/components/child/form/fieldset.vue";
import { Component, Prop, Watch } from "@/decorators";
import InformacoesNfeModel from "@/models/notafiscaleletronica/dados/informacoes/informacoesNfeModel";
import UsuarioModel from "@/models/usuarioModel";
import naturezaOperacaoService from "@/services/naturezaOperacaoService";
import { AppState } from "@/store/store";

@Component({
    components: {
        fieldsetComponent,
        dateTimePickerComponent,
        comboComponent,
    },
    computed: mapState({
        usuarioLogado: (state: AppState) => state.session.usuarioLogado,
    }),
})
export default class ImportacaoNfeDadosGeraisComponent extends Vue {
    // State computed props
    usuarioLogado: UsuarioModel;

    @Prop({ type: InformacoesNfeModel, required: true }) model: InformacoesNfeModel;

    cfopText = "";
    cfopOptions: Array<Object> = [];

    private async carregarCfops() {
        this.cfopOptions = await naturezaOperacaoService.comboCached(this.usuarioLogado.franquiaId);
    }

    @Watch("model.detalhes", { deep: true })
    private async onModelChange() {
        this.cfopText = `${this.model.detalhes?.[0]?.produto?.cfop ?? ""} - ${
            this.model.identificacao?.naturezaOperacao ?? ""
        }`;

        const cfop = this.cfopOptions.find(item => item["codigo"] == Number(this.model.detalhes?.[0]?.produto?.cfop));
        if (cfop) {
            this.model.naturezaOperacaoId = cfop["value"];
        }
    }

    private async mounted() {
        await this.carregarCfops();
    }
}
